
//local
export const API_BASE_URL= 'http://192.168.2.46:8081/api';

//staging
// export const API_BASE_URL = 'https://web-v2a-staging.netsetsoftware.pro/api';
   
//testing
// export const API_BASE_URL = 'http://43.204.197.104:8081/api';
